module.exports = "<div *ngIf=\"chart\">\n    <canvas id=\"canvas\">{{ chart }}</canvas>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/chart/chart.component.html
// module id = ./src/app/chart/chart.component.html
// module chunks = main